<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
      @openRelocationDialog="openRelocationDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @printTag="printTag"
        @batchRelocation="batchRelocation"
        :checkedCount="checkedCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="dialogVisible"
      show-close
      :visible.sync="dialogVisible"
      width="650px"
      :title="$l('dialog_title_select_warehouse') || '选择移库库位'"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
      v-el-dialog-drag
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="170px"
        onsubmit="return false"
        :rules="rules"
        style="margin-top: 20px;margin-bottom: 20px;"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item
              :label="$l('form_label_relocation_location_no') || '移库库位号'"
              prop="locationCode"
            >
              <el-cascader
                :options="treeData"
                :props="{
                  emitPath: false,
                  checkStrictly: true,
                  value: 'code',
                  label: 'label',
                }"
                size="small"
                ref="cascaderFunctionTreeRef"
                v-model="formData.locationCode"
                filterable
                clearable
                style="width: 100%"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      checkedRow: [],
      treeData: [],
      formData: {},
      dialogVisible: false,
      rules: {
        locationCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterStorageLocationListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTreeData() {
      this.$api
        .warehouseTreeApi({ isLast: 'N' })
        .then((res) => {
          this.treeData = res.body.data
        })
        .catch(() => {})
    },

    printTag() {
      if (!this.checkedCount) {
        this.$message({
          message: this.$l('tip_select_relocation') || '请选择库位信息',
          type: 'warning',
        })
        return
      }
      if (this.checkedCount > 20) {
        this.$message.warning('一次打印的数量不能超过20个')
        return
      }

      const listCode = this.checkedRow.map((row) => row.locationCode)

      let data = { locationCodeList: listCode }
      let fileName = '库位标签'
      this.$api.globalExportData(
        '/samplemanage/masterStorageLocation/print',
        data,
        fileName
      )
      this.clearCheckboxRow()
    },
    batchRelocation() {
      if (!this.checkedCount) {
        this.$message({
          message: this.$l('tip_select_relocation') || '请选择库位信息',
          type: 'warning',
        })
        return
      }

      // 获取已关联请款单的结算单编号
      const errorKeys = this.checkedRow
        .filter((item) => item.isLast != 'Y')
        .map((item) => item.locationNo)

      if (errorKeys && errorKeys.length) {
        this.$message({
          message: `库位[${errorKeys.join('][')}]不是末级库位,不能移库`,
          type: 'warning',
        })
        return
      }

      this.getTreeData()
      const listCode = this.checkedRow.map((row) => row.locationCode)
      this.formData.locationCodeList = listCode
      this.dialogVisible = true
    },
    openRelocationDialog(row) {
      if (row.isLast != 'Y') {
        this.$message({
          message: `库位[${row.locationNo} ]不是末级库位,不能移库`,
          type: 'warning',
        })
        return
      }
      this.getTreeData()
      this.formData.locationCodeList = [row.locationCode]
      this.dialogVisible = true
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    close() {
      this.dialogVisible = false
      this.formData = {}
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.$confirm(
        this.$l('tip_migration_operation') || '确认要执行移库操作吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()

        this.$api
          .masterStorageLocationRelocationApi({ ...this.formData })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.close()
            this.clearCheckboxRow()
            this.$refs.header.query()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
